import { UserEmail } from 'able-lib'
import gql from 'graphql-tag'
import { LevelId } from 'able-lib/index'
// import { USER_FIELDS } from 'src/lib/queries/fields'

export interface GqlUserVariable {
  email: UserEmail;
}

export interface GqlSectionVariable {
  levelId: LevelId;
}

export const QUERY_GET_USER = gql`
  query getUserProfile($email: String!) {
    users: user(where: {email: {_eq: $email}}) {
      id
      email
      title
      firstName: firstname
      middleName: middlename
      lastName: lastname
      nickname
      birthDate: birth_date
      avatarUrl: avatar_url
      parent: user {
        id
        email
      }
      parentId: parent_id
      userRoles: user_roles(order_by: {role: {id: asc}}) {
        role {
          id
          name
        }
      }
      userLocations: user_locations {
        location {
          id
          name
        }
      }
      user_groups(where: {group: {type: {_eq: SECTION}}}) {
        group {
          name
        }
      }
    }
  }
`

export const QUERY_GET_USERS = gql`
  query getUsers {
    user (
      order_by: [
        { lastname: asc },
        { firstname: asc }
      ]
    ) {
      id
      lastname
      firstname
      email
      user_roles {
        role {
          id
          name
        }
      }
      updated_at
      created_at
    }
  }
`

export const QUERY_GET_ALL_USERS = gql`
  query getAllUsers (
    $limit: Int!,
    $offset: Int!,
    $search: String!,
    $levelId: Int!
  ) {
    user (
      limit: $limit,
      offset: $offset ,
      where: {
        _or: [
          { firstname: { _ilike: $search } },
          { lastname: { _ilike: $search } },
          { email: { _ilike: $search } }
        ]
      },
      order_by: {
        id: asc
      }
    ) {
      id
      lastname
      firstname
      email
      user_roles {
        role {
          id
          name
        }
      }
      updated_at
      created_at
    }
    user_aggregate (
      where: {
        _or: [
          { firstname: { _ilike: $search } },
          { lastname: { _ilike: $search } },
          { email: { _ilike: $search } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export const QUERY_GET_ALL_USERS_BY_LEVEL = gql`
  query getAllUsersByLevel (
    $limit: Int!,
    $offset: Int!,
    $search: String!,
    $levelId: Int!
  ) {
    user (
      limit: $limit,
      offset: $offset ,
      where: {
        _or: [
          { firstname: { _ilike: $search } },
          { lastname: { _ilike: $search } },
          { email: { _ilike: $search } }
        ],
        user_levels: {
          level: {
            id: { _eq: $levelId }
          }
        }
      },
      order_by: {
        id: asc
      }
    ) {
      id
      lastname
      firstname
      email
      user_roles {
        role {
          id
          name
        }
      }
      updated_at
      created_at
    }
    user_aggregate (
      where: {
        _or: [
          { firstname: { _ilike: $search } },
          { lastname: { _ilike: $search } },
          { email: { _ilike: $search } }
        ],
        user_levels: {
          level: {
            id: { _eq: $levelId }
          }
        }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`

export const QUERY_PARENT_LIST = gql`
  query getParentList {
    parent: user (
      where: {
        user_roles: {
          role_id: { _eq: 10 }
        }
      }
    ) {
      id,
      firstName: firstname,
      lastName: lastname,
      email
    }
  }
`

export const QUERY_CHECK_EXISTING_EMAIL = gql`
  query getUserEmail (
    $id: Int,
    $email: String!
  ) {
    userAggregate: user_aggregate (
      where: {
        _and: [
          { id: { _neq: $id } },
          { email: { _eq: $email } }
        ]
      }
    ) {
      aggregate {
        count
       }
    }
  }
`

export const QUERY_GET_USER_BY_ID = gql`
  query getUserProfile($id: Int!) {
    user: user_by_pk(id: $id) {
      id
      email
      title
      firstName: firstname
      middleName: middlename
      lastName: lastname
      nickname
      birthDate: birth_date
      avatarUrl: avatar_url
      parentId: parent_id
      status: status
      userRoles: user_roles(
        order_by: {
          role: { id: asc }
        }
      ) {
        role {
          id
          name
        }
      }
      userLevels: user_levels {
        level {
          id
          name
        }
      }
      userLocations: user_locations {
        location {
          id
          name
        }
      }
    }
    userLevels: user_level (
      where: {
        user_id: { _eq: $id }
      }
    ) {
      level {
        id
        name
      }
    }
  }
`

export const QUERY_GET_NESTED_OBJECT_LISTS_FOR_USER_STORE = gql`
  query getNestedObjectListsForUser {
    roles: role {
      id
      name
    },
    locations: location {
      id
      name
    }
  }
`

export const MUTATION_INSERT_USER = gql`
  mutation insertUser (
    $firstName: String!,
    $lastName: String!,
    $middleName: String,
    $nickname: String!,
    $email: String!,
    $birthDate: String!,
    $title: String!,
    $avatarUrl: String,
    $parentId: Int
  ) {
    insert_user (objects: {
      firstname: $firstName,
      lastname: $lastName,
      middlename: $middleName,
      nickname: $nickname,
      email: $email,
      birth_date: $birthDate,
      title: $title,
      parent_id: $parentId,
      avatar_url: $avatarUrl
    }) {
      affected_rows
      returning {
        id
      }
    }
  }
`

export const MUTATION_UPDATE_USER = gql`
  mutation updateUser (
    $id: Int!,
    $firstName: String!,
    $lastName: String!,
    $middleName: String,
    $nickname: String!,
    $email: String!,
    $birthDate: String!,
    $title: String!,
    $avatarUrl: String,
    $parentId: Int
  ) {
    update_user(
      where: { id: { _eq: $id }},
      _set: {
        firstname: $firstName,
        lastname: $lastName,
        middlename: $middleName,
        nickname: $nickname,
        email: $email,
        birth_date: $birthDate,
        title: $title,
        parent_id: $parentId,
        avatar_url: $avatarUrl
      }
    ) {
      affected_rows
    }
  }
`

export const MUTATION_DEACTIVATE_USER = gql`
  mutation deactivateUser (
    $id: Int!
  ) {
    update_user(
      where: { id: { _eq: $id }},
      _set: {
        status: DELETED
      }
    ) {
      affected_rows
    }
  }
`

export const MUTATION_REACTIVATE_USER = gql`
  mutation reactivateUser (
    $id: Int!
  ) {
    update_user(
      where: { id: { _eq: $id }},
      _set: {
        status: PUBLISHED
      }
    ) {
      affected_rows
    }
  }
`

export const QUERY_INSERT_USER_GROUP = gql`
  mutation insertUserGroup($user_groupObject: [user_group_insert_input!]!) {
    insert_user_group(objects: $user_groupObject) {
      returning {
        group_id
        role_id
        user_id
      }
    }
  }
`

export const MUTATION_INSERT_USER_ROLE = gql`
  mutation insertUserRole (
    $userId: Int!,
    $roleId: Int!
  ) {
    insert_user_role (objects: [{
      user_id: $userId,
      role_id: $roleId
    }]) {
      affected_rows
    }
  }
`

export const MUTATION_DELETE_USER_ROLE = gql`
  mutation deleteUserRole (
    $userId: Int!,
    $roleId: Int!
  ) {
    delete_user_role (
      where: {
        user_id: { _eq: $userId },
        role_id: { _eq: $roleId }
      }
    ) {
      affected_rows
    }
  }
`

export const MUTATION_INSERT_USER_LOCATION = gql`
  mutation insertUserLocation (
    $userId: Int!,
    $locationId: Int!
  ) {
    insert_user_location (objects: [{
      user_id: $userId,
      location_id: $locationId
    }]) {
      affected_rows
    }
  }
`

export const MUTATION_DELETE_USER_LOCATION = gql`
  mutation deleteUserLocation (
    $userId: Int!,
    $locationId: Int!
  ) {
    delete_user_location (
      where: {
        user_id: { _eq: $userId },
        location_id: { _eq: $locationId }
      }
    ) {
      affected_rows
    }
  }
`

export const MUTATION_INSERT_USER_LEVEL = gql`
  mutation insertUserLevel (
    $userId: Int!,
    $levelId: Int!
  ) {
    insert_user_level (objects: [{
      user_id: $userId,
      level_id: $levelId
    }]) {
      affected_rows
    }
  }
`

export const MUTATION_DELETE_USER_LEVEL = gql`
  mutation deleteUserLevel (
    $userId: Int!,
    $levelId: Int!
  ) {
    delete_user_level (
      where: {
        user_id: { _eq: $userId },
        level_id: { _eq: $levelId }
      }
    ) {
      affected_rows
    }
  }
`
